import React, {useState, useCallback} from 'react';
import {reducersState} from '../../redux/reducers';
import {useDispatch, useSelector} from 'react-redux';
import {logIn} from '../../redux/actions/user';
import {Link} from 'react-router-dom';
import {Loader} from '../../components';
import Pikado from '../../assets/icons/pikado-logo-text.png';
import pass_icon from '../../assets/icons/pwicon.svg';
import mail_icon from '../../assets/icons/mail.svg';
import {isValidEmail} from '../../constants';

const SignIn = () => {
  const isLoading: boolean = useSelector(
    (state: reducersState) => state.user.isLoadingRequest,
  );
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    if (validateInputs()) {
      dispatch(logIn(data.email, data.password));
    }
  };
  const [data, setData] = useState<{
    email: string;
    password: string;
    isValidEmail: boolean;
    isValidPass: boolean;
  }>({
    email: '',
    password: '',
    isValidEmail: true,
    isValidPass: true,
  });

  const validateInputs = () => {
    if (data.email.trim() != '' && data.password != '') {
      setData({
        ...data,
        isValidEmail: isValidEmail(data.email),
        isValidPass: data.password.length >= 6,
      });
      return data.password.length >= 6 && isValidEmail(data.email);
    }
    return false;
  };

  const updateData = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  }, []);

  return (
    <div className="min-vh-100 d-flex justify-content-center align-items-center bg-white">
      <div className="login-card p-3">
        <div className="pt-2">
          <i className="bi bi-bootstrap"></i>
          <img src={Pikado} alt="Pikado Logo" className="login-logo" />
          <h4 className="my-4 fw-medium">Sign in to your account</h4>
        </div>
        <form>
          <div className="mb-3">
            <label className="form-label fs-6">
              Your email{' '}
              {!data.isValidEmail && (
                <span className="text-danger"> * Invalid Email</span>
              )}{' '}
            </label>

            <div className="input-group">
              <input
                name="email"
                onChange={updateData}
                type="text"
                className="form-control"
                placeholder="Enter E-Mail"
              />
              <div className="input-group-text">
                <img src={mail_icon} alt="Email Icon" />
              </div>
            </div>
          </div>

          <div className="mb-4">
            <label className="form-label fs-6">Your password </label>
            {!data.isValidPass && (
              <p className="text-danger text-xs">
                Password must be at least 6 characters
              </p>
            )}
            <div className="input-group">
              <input
                name="password"
                type="password"
                onChange={updateData}
                className="form-control"
                placeholder="Enter Password"
              />
              <div className="input-group-text">
                <img src={pass_icon} alt="Password Icon" />
              </div>
            </div>
          </div>
        </form>
        <div className="d-grid">
          <button
            onClick={handleSubmit}
            type="submit"
            className="auth-btn mt-4"
            disabled={data.email == '' || data.password == ''}>
            Sign in
          </button>
        </div>
      </div>
      {isLoading && <Loader title="Loading" />}
    </div>
  );
};

export default SignIn;
